module.exports = __webpack_public_path__ + "static/images/groupPermissions/no_resource_selected.svg";